import React from 'react';
import { connect } from 'react-redux';

import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';

import {
  linksManagementLinksSetContentLinksUrls,
  linksManagementLinksSetDetectionLinksUrls,
} from '../../../actions/linksManagementActions';
import {
  getAreContentLinksBeingProcessed,
  getAreDetectionLinksBeingProcessed,
  getLinksManagementLinksContentLinkUrlsIntroduced,
  getLinksManagementLinksDetectionLinkUrlsIntroduced,
} from '../../../reducers/tasks/linksManagement';
import LinksManagementViewerActions from './LinksManagementViewerActions';
import LinksManagementViewerLinkList from './LinksManagementViewerLinkList';

const LinksManagementViewer = ({
  areContentLinksBeingProcessed,
  areDetectionLinksBeingProcessed,
  contentLinkUrls,
  detectionLinkUrls,
  form,
  linksManagementLinksSetContentLinksUrls,
  linksManagementLinksSetDetectionLinksUrls,
}) => {
  const handleLinksManagementLinksSetDetectionLinksUrls = detectionLinkUrls => {
    linksManagementLinksSetDetectionLinksUrls({ detectionLinkUrls });
  };

  const handleLinksManagementLinksSetContentLinksUrls = contentLinkUrls =>
    linksManagementLinksSetContentLinksUrls({ contentLinkUrls });
  return (
    <>
      <LinksManagementViewerLinkList
        linkType={LinkTypeEnum.DETECTION}
        linkUrls={detectionLinkUrls}
        handleChange={handleLinksManagementLinksSetDetectionLinksUrls}
        isLoading={areDetectionLinksBeingProcessed}
        form={form}
      />
      <LinksManagementViewerLinkList
        linkType={LinkTypeEnum.CONTENT}
        linkUrls={contentLinkUrls}
        handleChange={handleLinksManagementLinksSetContentLinksUrls}
        isLoading={areContentLinksBeingProcessed}
        form={form}
      />
      <LinksManagementViewerActions form={form} />
    </>
  );
};

const mapStateToProps = state => {
  return {
    detectionLinkUrls: getLinksManagementLinksDetectionLinkUrlsIntroduced(
      state
    ),
    contentLinkUrls: getLinksManagementLinksContentLinkUrlsIntroduced(state),
    areDetectionLinksBeingProcessed: getAreDetectionLinksBeingProcessed(state),
    areContentLinksBeingProcessed: getAreContentLinksBeingProcessed(state),
  };
};

export default connect(mapStateToProps, {
  linksManagementLinksSetDetectionLinksUrls,
  linksManagementLinksSetContentLinksUrls,
})(LinksManagementViewer);
